import React, { useState, useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import Login from "../../screens/Login";
import NetworkError from "../../screens/NetworkError";
import MainContent from "../../containers/MainContent";
import ResetPassword from "../../screens/ResetPassword";
import { getAdminToken, setSignedInHere } from "../../helpers/session";

export default function AuthRoutes() {
  const [savedToken, setSavedToken] = useState(getAdminToken());
  const [online, setOnline] = useState(navigator.onLine);
  const signedIn = Boolean(savedToken);

  useEffect(() => {
    setSignedInHere(signedIn);
  }, [signedIn]);

  useEffect(() => {
    // `pageshow` covers Back/Forward restoring the page, which fires no
    // online/offline event even if the connection changed meanwhile.
    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);
    window.addEventListener("pageshow", updateOnlineStatus);
    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
      window.removeEventListener("pageshow", updateOnlineStatus);
    };
  });

  function updateOnlineStatus() {
    setOnline(navigator.onLine);
  }

  function setToken(userToken) {
    localStorage.setItem("token", JSON.stringify(userToken));
    setSavedToken(userToken);
  }

  return (
    <BrowserRouter forceRefresh basename="/">
      <Switch>
        {!online && (
          <Route path="/">
            <NetworkError />
          </Route>
        )}
        <Route exact path="/reset-password">
          <ResetPassword />
        </Route>
        <Route path="/">
          {signedIn ? (
            <MainContent />
          ) : (
            <Login setToken={setToken} />
          )}
        </Route>
      </Switch>
    </BrowserRouter>
  );
}
